import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { map, tap } from 'rxjs/operators'
import { GetParticipantProfileGQL, GetParticipantProfileQuery } from '../../../generated/graphql'
import { TokenService } from 'sbs-common'

export type ChaserProfile = GetParticipantProfileQuery['getAccountById']

export const profileKey = 'SbsChaserProfileKey'
@Injectable({
  providedIn: 'root',
})
export class ChaserProfileService {
  constructor(
    private getParticipantProfileGQL: GetParticipantProfileGQL,
    private tokenService: TokenService,
  ) {}

  getChaserProfile(reload: boolean = false): Observable<ChaserProfile | null> {
    if (!reload) {
      const localStorageProfile = this.getProfileFromLocalStorage()
      if (localStorageProfile) {
        return of(localStorageProfile)
      }
    }
    return this.fetchProfile()
  }

  private fetchProfile(): Observable<ChaserProfile | null> {
    const id = this.tokenService.getUser()?.sub
    if (!id) {
      return of(null)
    }
    return this.getParticipantProfileGQL
      .fetch(
        {
          id,
        },
        {
          fetchPolicy: 'network-only',
        },
      )
      .pipe(
        map((result) => result.data.getAccountById),
        tap((profile) => {
          this.saveProfileToLocalStorage(profile)
        }),
      )
  }

  private saveProfileToLocalStorage(profile: ChaserProfile): void {
    try {
      const profileData = JSON.stringify(profile)
      localStorage.setItem(`${profileKey}`, profileData)
    } catch (error) {
      console.error('Error saving to localStorage', error)
    }
  }

  private getProfileFromLocalStorage(): ChaserProfile | null {
    try {
      const profileData = localStorage.getItem(`${profileKey}`)
      return profileData ? JSON.parse(profileData) : null
    } catch (error) {
      console.error('Error retrieving from localStorage', error)
      return null
    }
  }

  public clearProfileInLocalStorage(): void {
    localStorage.removeItem(`${profileKey}`)
  }
}
